import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'vw-calendar-months-header',
    imports: [TranslatePipe, CommonModule],
    templateUrl: './calendar-months-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './calendar-months-header.component.scss'
})
export class CalendarMonthsHeaderComponent {
  @Input() currentMonth: number;
}
